/** a Hand will point to an entity which holds a collection of Cards */
export type Hand = string;

export const HAND = "hand";
